import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import shortid from 'shortid';
import Fa from 'react-fontawesome';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { reduce, intersection, findIndex, each } from 'lodash';
import { Modal, Button } from 'react-bootstrap';
import SearchPath from '../../../../components/search-path';
import PathDisplay from '../../../../components/search-path/path';
import ConfirmButton from '../../../../components/confirm-button';
import SearchForm from '../../../../components/search-form';
import { getSearchQuery, cleanSubmitCriteria } from '../../../../components/search-form/search-form-reducer';
import styles from './styles.css';
import styles2 from '../FeedbackModulePage/styles.css';


const mutatedReorder = (list, startIndex, endIndex) => {
  const [removed] = list.splice(startIndex, 1);
  list.splice(endIndex, 0, removed);
  return list;
};


class SenderList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openModal: false,
      currentId: null,
      updateCount: 1,
      openQueryModal: false,
      currentSender: null,
      dragging: false,
      draggedId: null,
    };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.updateSearchPath = this.updateSearchPath.bind(this);
    this.filterNodes = this.filterNodes.bind(this);
    this.deleteRule = this.deleteRule.bind(this);
    this.openQueryModal = this.openQueryModal.bind(this);
    this.closeQueryModal = this.closeQueryModal.bind(this);
    this.updateQuery = this.updateQuery.bind(this);
    this.onDragEnd = this.onDragEnd.bind(this);
    this.renderRow = this.renderRow.bind(this);
  }

  openModal(currentId) {
    this.setState({ draggedId: null, openQueryModal: false, openModal: true, ...(currentId ? { currentId } : {}) });
  }

  closeModal() {
    this.setState({ openModal: false, currentId: null, openQueryModal: false });
  }

  onDragEnd(result) {
    const { source, destination } = result;
    if (!this.state.dragging && source.index !== destination.index) {
      const { senderConditions } = this.props;
      const destinationList = [...senderConditions];

      const draggedId = senderConditions[source.index] ? senderConditions[source.index]._id : null;

      mutatedReorder(
        destinationList,
        source.index,
        destination.index,
      );

      // sort
      each(destinationList, (s, o) => {
        s.order = o + 1;
      });

      this.setState({ dragging: true, draggedId: null }, () => {
        this.props.onChange(destinationList);
        this.setState({ updateCount: this.state.updateCount + 1 });
        this.setState({ dragging: false, draggedId });
      });
    }
  }

  openQueryModal(currentId) {
    let currentSender = null;
    if (currentId) {
      const idx = findIndex(this.props.senderConditions, { _id: currentId });
      if (idx >= 0) {
        currentSender = this.props.senderConditions[idx];
      }
    }
    this.setState({ draggedId: null, openModal: false, openQueryModal: true, currentSender, ...(currentId ? { currentId } : {}) });
  }

  closeQueryModal() {
    this.setState({ openModal: false, currentId: null, openQueryModal: false });
  }

  updateQuery() {
    const { senderQuery } = this.props;
    const newItems = [...this.props.senderConditions];
    const index = findIndex(this.props.senderConditions, { _id: this.state.currentId });
    let draggedId = null;
    if (index >= 0) {
      newItems[index] = {
        ...newItems[index],
        query: cleanSubmitCriteria(senderQuery),
      };
      draggedId = newItems[index]._id;
    }
    this.props.onChange(newItems);
    this.setState({ updateCount: this.state.updateCount + 1, draggedId });
    this.closeQueryModal();
  }

  updateSearchPath(field) {
    const newItems = [...this.props.senderConditions];
    const index = findIndex(this.props.senderConditions, { _id: this.state.currentId });
    let draggedId = null;
    if (index >= 0) {
      newItems[index] = {
        ...newItems[index],
        field,
      };
      draggedId = newItems[index]._id;
    } else {
      const id = shortid.generate();
      newItems.push({
        _id: id,
        field,
        query: {},
        order: newItems.length,
      });
      draggedId = id;
    }
    this.props.onChange(newItems);
    this.setState({ updateCount: this.state.updateCount + 1, draggedId });
    this.closeModal();
  }

  deleteRule(rule) {
    let newItems = [...this.props.senderConditions];
    const index = findIndex(newItems, { _id: rule._id });
    if (index >= 0) {
      newItems = reduce(newItems, (items, item, idx) => {
        if (idx !== index) {
          items.push(item);
        }
        return items;
      }, []);
      this.props.onChange(newItems);
      this.setState({ updateCount: this.state.updateCount + 1 });
    }
  }

  filterNodes(node) {
    const { fields } = node;
    return reduce(fields, (items, field) => {
      const validReference = intersection(field.reference_to, ['account', 'Account', 'Contact', 'contact', 'User', 'systemuser']).length > 0;
      const idType = node.objectType === 'User' && field.is_key && field.type === 'id';

      const isValid = idType || validReference;
      if (isValid) {
        if (idType) {
          items.push({
            ...field,
            label: node.label,
            name: `${node.objectLabel} Info`,
          });
        } else {
          items.push(field);
        }
      }
      return items;
    }, []);
  }

  renderModal() {
    const { openModal } = this.state;
    const { isAccount } = this.props;

    return (
      <Modal show={openModal} onHide={this.closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>Select Sender Field</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <SearchPath
              paths={[]}
              onUpdate={this.updateSearchPath}
              selectedSearchPaths={[]}
              filterNodes={this.filterNodes}
              startingNode={isAccount ? 'Account' : 'Opportunity'}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div>
            <Button bsStyle="default" onClick={this.closeModal}>Cancel</Button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }

  renderQueryModal() {
    const { openQueryModal, currentSender } = this.state;
    const { disabled, isAccount } = this.props;
    let defaultCriteria = {
      _id: 'ROOT',
      type: 'groupAND',
      values: [],
    };
    if (currentSender && currentSender.query && (currentSender.query._id === 'ROOT' || currentSender.query.values)) {
      defaultCriteria = currentSender.query;
    }
    return (
      <Modal bsSize="lg" show={openQueryModal} onHide={this.closeQueryModal}>
        <Modal.Header closeButton>
          <Modal.Title>Trigger Conditions</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {currentSender !== null &&
            <div>
              <table>
                <tbody>
                  <tr>
                    <td width="80">Sender&nbsp;Field:&nbsp;</td>
                    <td><PathDisplay startingNode={isAccount ? 'Account' : 'Opportunity'} paths={currentSender.field} /></td>
                  </tr>
                </tbody>
              </table>
              <p />
            </div>
          }
          <div>
            <SearchForm
              onSearchChange={() => {
                /*
                this.setState({ [p]: true }, () => {
                  this.checkDirty();
                });
                */
              }}
              showRootLogicalORWarning
              disabled={disabled}
              standalone
              defaultCriteria={defaultCriteria}
              simpleMode
              type="automations/discovery-bot/sender"
              className={styles.field}
            />
          </div>
        </Modal.Body>
        <Modal.Footer className="clearfix">
          <Button className="pull-left" bsStyle="default" onClick={this.closeQueryModal}>Cancel</Button>
          <Button className="pull-right" bsStyle="primary" onClick={this.updateQuery}>Update</Button>
        </Modal.Footer>
      </Modal>
    );
  }

  renderRow(senderCondition, idx) {
    const { dragging, draggedId } = this.state;
    const { isAccount, disabled, senderConditions } = this.props;
    const arrow = (<span>&nbsp;<Fa name="angle-right" className="text-muted" /><Fa name="angle-right" className="text-muted" />&nbsp;</span>);
    const ifWord = idx === 0 ? 'If' : 'else if';
    const blinking = draggedId === senderCondition._id;

    let arrowName = 'arrows-v';
    const hasMultiple = senderConditions.length > 1;
    if (hasMultiple) {
      if (idx === 0) {
        arrowName = 'long-arrow-down';
      } else if (idx === senderConditions.length - 1) {
        arrowName = 'long-arrow-up';
      }
    }
    if (dragging) {
      arrowName = 'spinner';
    }

    return (
      <Draggable draggableId={senderCondition._id} key={senderCondition._id} index={idx}>
        {(provided, snapshot) => (
          <tr
            ref={provided.innerRef}
            {...provided.draggableProps}
            className={`${snapshot.isDragging ? styles2.dragging : null}`}
            style={provided.draggableProps.style}
          >
            {hasMultiple &&
              <td
                width="40"
                className="text-center"
                {...provided.dragHandleProps}
              >
                <Fa
                  name={arrowName}
                  spin={dragging}
                />
              </td>
            }
            <td>
              <div className={blinking ? 'animated flash' : ''}>
                {!hasMultiple && <div className="hidden"><span {...provided.dragHandleProps} /></div>}
                {idx > 0 && arrow}
                <span className="label label-success">{ifWord}</span>
                {' '}
                {disabled
                  ? "conditions are true"
                  : <a
                      href=""
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        this.openQueryModal(senderCondition._id);
                      }}
                    >
                      conditions are true
                    </a>
                }
              </div>
            </td>
            <td>
              <div className={blinking ? 'animated flash' : ''}>
                <table>
                  <tbody>
                    <tr>
                      <td><span className="label label-success">then use</span>&nbsp;</td>
                      <td width="99%">
                        {disabled
                          ? <PathDisplay startingNode={isAccount ? 'Account' : 'Opportunity'} paths={senderCondition.field} />
                          : <a
                              href=""
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                this.openModal(senderCondition._id);
                              }}
                            >
                              <PathDisplay startingNode={isAccount ? 'Account' : 'Opportunity'} paths={senderCondition.field} />
                            </a>
                        }
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>

            <td>
              <ConfirmButton
                size="sm"
                disabled={disabled}
                confirmMessage="?"
                confirmStyle="link"
                onConfirm={() => { this.deleteRule(senderCondition); }}
              >
                <Fa name="trash" />
              </ConfirmButton>
            </td>
          </tr>
        )}
      </Draggable>
    );
  }

  renderList() {
    const { updateCount } = this.state;
    const { senderConditions, isAccount } = this.props;
    const defaultConditions = (
      <span>
        <code>{isAccount ? 'Account' : 'Opportunity'}</code>&rsquo;s <code>Owner</code> as a sender
      </span>
    );

    if (!senderConditions || senderConditions.length === 0) {
      return (
        <table key={updateCount} className={`table table-bordered table-striped ${styles2.table}`}>
          <thead>
            <tr>
              <th>Default Sender Field</th>
            </tr>
          </thead>
          <tbody>
              <tr>
                <td >
                  <span className="label label-success">use</span> {defaultConditions}
                </td>
              </tr>
            </tbody>
        </table>
      );
    }

    const hasMultiple = senderConditions.length > 1;

    return (
      <DragDropContext onDragEnd={this.onDragEnd}>
        <Fragment>
          <table key={updateCount} className={`table table-bordered table-striped ${styles2.table}`}>
            <thead>
              <tr>
                {hasMultiple && <th width="40">&nbsp;</th>}
                <th>Trigger Conditions</th>
                <th>Sender Field</th>
                <th width="40">&nbsp;</th>
              </tr>
            </thead>
            <Droppable droppableId="drop">
              {(provided, snapshot) => (
                <tbody
                  ref={provided.innerRef}
                  className={snapshot.isDraggingOver ? styles2.DraggingOver : null}
                >
                  {senderConditions.map(this.renderRow)}
                  {provided.placeholder}
                </tbody>
              )}
            </Droppable>
            <tbody>
              <tr>
                {hasMultiple && <td></td>}
                <td>
                  <span className="label label-success">otherwise</span>
                </td>
                <td colSpan="2">
                  <span className="label label-success">use</span> {defaultConditions}
                </td>
              </tr>
            </tbody>
          </table>
        </Fragment>
      </DragDropContext>
    );
  }

  renderInstructions() {
    return (
      <div className="well well-sm">
        Define the field(s), and conditions, TruSales should use to determine who the email sender will be for feedback requests.
      </div>
    );
  }

  render() {
    return (
      <div>
        {this.renderInstructions()}
        {this.renderModal()}
        {this.renderQueryModal()}
        {this.renderList()}
        <Button onClick={this.openModal} bsStyle="default" bsSize="sm" disabled={this.props.disabled}>
          <Fa name="plus" /> Add Sender Condition Block
        </Button>
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    senderQuery: getSearchQuery('automations/discovery-bot/sender', state),
  };
}

SenderList.propTypes = {
  onClose: PropTypes.func,
  onAdd: PropTypes.func,
  onChange: PropTypes.func,
  open: PropTypes.bool,
  isAccount: PropTypes.bool,
  disabled: PropTypes.bool,
  senderConditions: PropTypes.arrayOf(PropTypes.shape({
    _id: PropTypes.string,
    field: PropTypes.arrayOf(PropTypes.string),
    order: PropTypes.number,
    query: PropTypes.shape({}),
  })),
  senderQuery: PropTypes.shape({}),
};
SenderList.defaultProps = {
  open: false,
  onClose: () => {},
  onAdd: () => {},
  onChange: () => {},
  isAccount: false,
  senderConditions: [],
  disabled: false,
  senderQuery: {},
};

export default connect(mapStateToProps)(SenderList);
